<template>
  <div align="center" justify="center" class="page mt-3">
    <ValidationObserver
      v-slot="{ handleSubmit }"
    >
      <v-card class="box ma-auto px-6 px-sm-8 py-5 d-flex flex-column justify-space-between  align-center rounded">
        <div class="text">
          <h1 class="mb-3">{{ $t('forgotPassword.title') }}</h1>
          <p>
            {{ $t('forgotPassword.description') }}
          </p>
        </div>
        <text-field
          v-model="email"
          :rules="{
            required: true,
            email: true,
          }"
          class="input"
          name="email"
          type="text"
          :placeholder="$t('base.email')"
        >
          <template #prepend-inner>
            <iconMail class="mt-1 mr-1"></iconMail>
          </template>
        </text-field>

        <v-btn class="primary btn-text py-7 mt-2 mb-3" dark @click="handleSubmit(resetPassword)">{{ $t('forgotPassword.resetPassword') }}</v-btn>

      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import textField from '@/components/base/textField';
import iconMail from '@/static/img/mail.svg';
import toastr from '@/plugins/toastr';

export default {
  name: 'forgotPassword',

  components: {
    ValidationObserver,
    textField,
    iconMail,
  },

  data () {
    return {
      email: '',
    };
  },

  methods: {
    async resetPassword () {
      await this.$store.dispatch('authorization/TRIGGER_FORGOT_PASSWORD_EMAIL', { email: this.email, language: this.$route.params.locale });
      toastr.success(`${this.$t('forgotPassword.recEmail')} </br></br> ${this.$t('forgotPassword.doNotReceive')} <button type="button" class="btn--resend-email">${this.$t('forgotPassword.resend')}!</button>`, null, 300000);
    },
  },

  mounted () {
    // add listener for button in toastr
    // because v-on does not work with external html structure
    document.querySelector('body').addEventListener('click', (event) => {
      if (event.target.classList.contains('btn--resend-email')) {
        this.resetPassword();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.box {
  background: #fff;
  border: 1px solid #E5E5E5;
  max-width: 330px
}
  .topbar {
    margin-bottom: 50px;
    display: flex;

    .topbar-text {
      // color: #3736a0;
      font-weight: bold;
      display: flex;
      margin-left: 10px;
    }
  }

  .text {
    // color: #3736a0;
    text-align: left;
    // line-height: 1;

    h1 {
      font-weight: 900;
      font-size: 23px;
    }
  }
  .input {
    width: 100%;
  }

  .btn-text {
    width: 100%;
  }
</style>
